import React from "react";
import "./AboutApp.css";
function AboutApp() {
  return (
    <div>
      <a href="/home">
        <img
          className="abt__img"
          src="images/login-logo.svg"
          alt="Go to Home"
        />
      </a>
      <div className="aboutapp">
        <h2>About the App</h2>
        <h3>
          Linkedin clone app, designed by <a href="/developer">Niranjan</a> for
          end-semester college project. Tried to cover most of the frontend
          features of Linkedin with Reactjs, Material UI for UI, Redux for
          backend and Firebase for authentication and authorization functions.
          If you need to report an issue or suggest any other improvements feel
          free to reach me out. you can reach me at my Developer page{" "}
          <a href="/developer">Developer page</a>
        </h3>
      </div>
    </div>
  );
}

export default AboutApp;
